import { WEEK_DAYS } from '@/values/general.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-assign-main-placeholder',
})
export default class EdAssignMainPlaceholderComponent extends Vue {
  @Prop({ required: true }) readonly placeholders: any[];
  @Prop({ required: true }) readonly selectedPlaceholderId: number;
  @Prop({ required: true }) readonly defaultPlaceholderId: number;
  @Prop({ required: true, default: '' }) readonly weekday: string;
  @Prop({ required: true, default: '' }) readonly date: string;
  @Prop({ required: true, default: '' }) readonly startTime: string;
  @Prop({ required: true, default: '' }) readonly endTime: string;
  @Prop({ required: true, default: '' }) readonly entryId: string;

  @Emit('selectPlaceholder')
  selectPlaceholder() {
    return {
      placeholderId: this.selected,
      date: this.date,
      entryId: this.entryId,
      defaultPlaceholderId: this.defaultPlaceholderId
    };
  }

  WEEK_DAYS = WEEK_DAYS
  selected = null;
  

  get formattedDate() {
    return this.date.split('-').reverse().join('/')
  }

  get formattedPlaceholders() {
    return this.placeholders.map(el => {
      return {
        text: el.contentTitle,
        value: el.id,
        color: el.color
      }
    })
  }

  created() {
    this.selected = this.selectedPlaceholderId
  }
  
  reset() {
    this.selected = this.selectedPlaceholderId
  }
}